// src/components/icons.js
import { FaXTwitter } from 'react-icons/fa6';
import {
  // Major Social Networks
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaTiktok,
  FaSnapchat,
  FaPinterest,
  FaReddit,
  FaTumblr,
  FaYoutube,
  FaTwitch,
  FaDiscord,
  FaTelegram,
  FaWhatsapp,
  FaSkype,
  FaSlack,
  
  
  // Professional & Portfolio
  FaBehance,
  FaDribbble,
  FaEtsy,
  FaFlickr,
  FaUnsplash,
  FaDeviantart,
  
  // Developer/Coding
  FaGithub,
  FaGitlab,
  FaStackOverflow,
  FaCodepen,
  
  // Music & Audio
  FaSpotify,
  FaSoundcloud,
  FaLastfm,
  FaBandcamp,
  FaMixcloud,
  
  // Writing/Blogging
  FaMedium,
  FaDev,
  FaWordpress,
  FaBlogger,
  
  // Gaming
  FaSteam,
  FaPlaystation,
  FaXbox,
  // FaTwitch already imported above
  
  // Shopping/Business
  FaShopify,
  FaAmazon,
  FaEbay,
  FaYelp,
  FaPatreon,
  FaPaypal,
  FaStripe,
  FaKickstarter,
  
  // Contact/Basic
  FaEnvelope,
  FaPhone,
  FaGlobe,
  FaMapMarkerAlt,
  FaHome,
  FaRss,
  
  // Files/Documents
  FaFile,
  FaFilePdf,
  FaDownload,
  
  // Crypto
  FaBitcoin,
  FaEthereum,
  
  // Other popular services
  FaImdb,
  FaGoodreads,
  FaStrava,
  FaFoursquare,
  FaTripadvisor
} from 'react-icons/fa';

// Import Simple Icons (SI) for modern platforms not available in FontAwesome
import {
  SiBluesky,
  SiMastodon,
  SiThreads,
  SiOnlyfans,
  SiSubstack,
  SiBereal,
  SiRoblox,
  
  SiDiscogs,
  SiLetterboxd
 
} from 'react-icons/si';

// Lucide icons (more modern, simple style)
import {
  LuFacebook,
  LuInstagram,
  LuTwitter,
  LuLinkedin,
  LuYoutube,
  LuGithub,
  LuMail,
  LuPhone,
  LuGlobe,
  LuMapPin,
  LuMusic,
  LuBookOpen,
  LuBriefcase,
  LuShoppingBag,
  LuMessageCircle,
  LuCalendar,
  LuCreditCard,
  LuHeart,
  LuStar,
  LuCamera,
  LuUsers
} from 'react-icons/lu';

// Note: To use the Simple Icons (SI) set, make sure to install:
// npm install react-icons --save

const availableIcons = [
  // Major Social Networks
  { component: FaFacebook, name: 'Facebook', category: 'social' },
  { component: FaInstagram, name: 'Instagram', category: 'social' },
  { component: FaTwitter, name: 'Twitter', category: 'social' },
  { component: FaLinkedin, name: 'LinkedIn', category: 'social' },
  { component: FaTiktok, name: 'TikTok', category: 'social' },
  { component: FaSnapchat, name: 'Snapchat', category: 'social' },
  { component: FaPinterest, name: 'Pinterest', category: 'social' },
  { component: FaReddit, name: 'Reddit', category: 'social' },
  { component: FaTumblr, name: 'Tumblr', category: 'social' },
  { component: FaXTwitter, name: 'Twitter (X)', category: 'social' },
  
  // Newer Social Networks
  { component: SiBluesky, name: 'Bluesky', category: 'social' },
  { component: SiMastodon, name: 'Mastodon', category: 'social' },
  { component: SiThreads, name: 'Threads', category: 'social' },
  { component: SiOnlyfans, name: 'OnlyFans', category: 'social' },
  { component: SiBereal, name: 'BeReal', category: 'social' },
 
  
  // Video Platforms
  { component: FaYoutube, name: 'YouTube', category: 'video' },
  { component: FaTwitch, name: 'Twitch', category: 'video' },
  
  // Communication
  { component: FaDiscord, name: 'Discord', category: 'communication' },
  { component: FaSkype, name: 'Skype', category: 'communication' },
  { component: FaSlack, name: 'Slack', category: 'communication' },
  { component: FaTelegram, name: 'Telegram', category: 'communication' },
  { component: FaWhatsapp, name: 'WhatsApp', category: 'communication' },
  
  // Music & Audio
  { component: FaSpotify, name: 'Spotify', category: 'music' },
  { component: FaSoundcloud, name: 'Soundcloud', category: 'music' },
  { component: FaLastfm, name: 'Last.fm', category: 'music' },
  { component: FaBandcamp, name: 'Bandcamp', category: 'music' },
  { component: FaMixcloud, name: 'Mixcloud', category: 'music' },
  { component: SiDiscogs, name: 'Discogs', category: 'music' },
  
  // Blogging & Writing
  { component: FaMedium, name: 'Medium', category: 'blogging' },
  { component: FaDev, name: 'Dev.to', category: 'blogging' },
  { component: FaWordpress, name: 'WordPress', category: 'blogging' },
  { component: FaBlogger, name: 'Blogger', category: 'blogging' },
  { component: SiSubstack, name: 'Substack', category: 'blogging' },
  
  // Professional & Portfolio
  { component: FaBehance, name: 'Behance', category: 'professional' },
  { component: FaDribbble, name: 'Dribbble', category: 'professional' },
  { component: FaEtsy, name: 'Etsy', category: 'professional' },
  { component: FaFlickr, name: 'Flickr', category: 'professional' },
  { component: FaUnsplash, name: 'Unsplash', category: 'professional' },
  { component: FaDeviantart, name: 'DeviantArt', category: 'professional' },
  
  // Developer Platforms
  { component: FaGithub, name: 'GitHub', category: 'developer' },
  { component: FaGitlab, name: 'GitLab', category: 'developer' },
  { component: FaStackOverflow, name: 'Stack Overflow', category: 'developer' },
  { component: FaCodepen, name: 'Codepen', category: 'developer' },
  
  // Gaming
  { component: FaSteam, name: 'Steam', category: 'gaming' },
  { component: FaPlaystation, name: 'PlayStation', category: 'gaming' },
  { component: FaXbox, name: 'Xbox', category: 'gaming' },
  { component: SiRoblox, name: 'Roblox', category: 'gaming' },
  
  // Business & Reviews
  { component: FaYelp, name: 'Yelp', category: 'business' },
  { component: FaTripadvisor, name: 'Tripadvisor', category: 'business' },
  { component: FaFoursquare, name: 'Foursquare', category: 'business' },
  { component: FaImdb, name: 'IMDB', category: 'entertainment' },
  { component: SiLetterboxd, name: 'Letterboxd', category: 'entertainment' },
  
  // Reading
  { component: FaGoodreads, name: 'Goodreads', category: 'reading' },
  
  // Crypto & Finance
  { component: FaBitcoin, name: 'Bitcoin', category: 'crypto' },
  { component: FaEthereum, name: 'Ethereum', category: 'crypto' },
  { component: FaPaypal, name: 'PayPal', category: 'payment' },
  { component: FaStripe, name: 'Stripe', category: 'payment' },
  { component: FaKickstarter, name: 'Kickstarter', category: 'crowdfunding' },
  { component: FaPatreon, name: 'Patreon', category: 'crowdfunding' },
  
  // Shopping
  { component: FaAmazon, name: 'Amazon', category: 'shopping' },
  { component: FaEbay, name: 'eBay', category: 'shopping' },
  { component: FaShopify, name: 'Shopify', category: 'shopping' },
  
  // Others
  { component: FaStrava, name: 'Strava', category: 'fitness' },
  
  // Contact 
  { component: FaEnvelope, name: 'Email', category: 'contact' },
  { component: FaPhone, name: 'Phone', category: 'contact' },
  { component: FaGlobe, name: 'Website', category: 'contact' },
  { component: FaMapMarkerAlt, name: 'Location', category: 'contact' },
  { component: FaHome, name: 'Home', category: 'contact' },
  { component: FaRss, name: 'RSS Feed', category: 'contact' },
  
  // Files/Downloads
  { component: FaFile, name: 'File', category: 'files' },
  { component: FaFilePdf, name: 'PDF', category: 'files' },
  { component: FaDownload, name: 'Download', category: 'files' },
  
  // Lucide Icons (more minimal style)
  { component: LuFacebook, name: 'Facebook (Simple)', category: 'social' },
  { component: LuInstagram, name: 'Instagram (Simple)', category: 'social' },
  { component: LuTwitter, name: 'Twitter (Simple)', category: 'social' },
  { component: LuLinkedin, name: 'LinkedIn (Simple)', category: 'social' },
  { component: LuYoutube, name: 'YouTube (Simple)', category: 'video' },
  { component: LuGithub, name: 'GitHub (Simple)', category: 'developer' },
  { component: LuMail, name: 'Email (Simple)', category: 'contact' },
  { component: LuPhone, name: 'Phone (Simple)', category: 'contact' },
  { component: LuGlobe, name: 'Website (Simple)', category: 'contact' },
  { component: LuMapPin, name: 'Location (Simple)', category: 'contact' },
  { component: LuMusic, name: 'Music (Simple)', category: 'music' },
  { component: LuBookOpen, name: 'Book (Simple)', category: 'reading' },
  { component: LuBriefcase, name: 'Work (Simple)', category: 'professional' },
  { component: LuShoppingBag, name: 'Shop (Simple)', category: 'shopping' },
  { component: LuMessageCircle, name: 'Message (Simple)', category: 'communication' },
  { component: LuCalendar, name: 'Calendar (Simple)', category: 'utility' },
  { component: LuCreditCard, name: 'Payment (Simple)', category: 'payment' },
  { component: LuHeart, name: 'Heart (Simple)', category: 'social' },
  { component: LuStar, name: 'Star (Simple)', category: 'social' },
  { component: LuCamera, name: 'Photos (Simple)', category: 'media' },
  { component: LuUsers, name: 'Community (Simple)', category: 'social' }
];

export default availableIcons;